import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LanguageIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
      />
      <path
        d="M12 22C14.2091 22 16 17.5228 16 12C16 6.47715 14.2091 2 12 2C9.79086 2 8 6.47715 8 12C8 17.5228 9.79086 22 12 22Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
      />
      <path d="M2 9.25H22" stroke={color} strokeWidth={strokeWidth || 1.5} />
      <path d="M2 15.25H22" stroke={color} strokeWidth={strokeWidth || 1.5} />
    </BaseIcon>
  ),
);

LanguageIcon.displayName = 'LanguageIcon';
